import { mapGetters } from 'vuex'
import HipotekaMap from './../components/hipoteka/hipotekaMap'
export default {
  computed: {
    ...mapGetters(['hipotekaTipas']),
    hipotekaTabs() {
      return {
        hipotekaPranesimas: {
          title: 'Dokumento duomenys',
          route: 'hipotekaPranesimas',
          errorTab: 'pranesimo-duomenys',
        },
        hipotekaTeikejas: {
          title: 'Duomenų teikėjas',
          route: 'hipotekaTeikejas',
          errorTab: 'duomenu-teikejas',
        },
        hipotekaSkolininkai: {
          title: 'Skolininkai',
          route: 'hipotekaSkolininkai',
          errorTab: 'skolininkai',
        },
        hipotekaIkaitoDavejai: {
          title: this.ikaitoDavejaiTitle,
          route: 'hipotekaIkaitoDavejai',
          errorTab: 'davejai',
        },
        hipotekaIkaitoDavejaiHR: {
          title: this.ikaitoDavejaiTitleHR,
          route: 'hipotekaIkaitoDavejaiHR',
          errorTab: 'davejaiHR',
        },
        hipotekaKreditoriai: {
          title: 'Kreditoriai',
          route: 'hipotekaKreditoriai',
          errorTab: 'kreditoriai',
        },
        hipotekaTurtas: {
          title: this.turtasTitle,
          route: 'hipotekaTurtas',
          errorTab: 'turtas',
        },
        turtasObjektas: {
          route: 'turtasObjektas',
          errorTab: 'turtas-objektas',
        },
        hipotekaPrievole: {
          title: this.prievoleTitle,
          route: 'hipotekaPrievole',
          errorTab: 'prievole',
        },
        prievoleObjektas: {
          route: 'prievoleObjektas',
          errorTab: 'prievole-objektas',
        },
        hipotekaSandoris: {
          title: 'Sandorio informacija',
          route: 'hipotekaSandoris',
          errorTab: 'sandoris',
        },
        hipotekaNustatymas: {
          title: 'Nustatymo informacija',
          route: 'hipotekaNustatymas',
          errorTab: 'nustatymas',
        },
        hipotekaSalyginis: {
          title: this.salyginisTitle,
          route: 'hipotekaSalyginis',
          errorTab: 'salyginis',
        },
        hipotekaVykdomasis: {
          title: 'Notaro vykdomasis įrašas',
          route: 'hipotekaVykdomasis',
          errorTab: 'vykdomasis',
        },
        hipotekaKitaInfo: {
          title: 'Kita informacija',
          route: 'hipotekaKitaInfo',
          errorTab: 'kitainformacija',
        },
        sutartisSalys: {
          title: 'Sutarties šalys',
          route: 'sutartisSalys',
          errorTab: 'sutarties-salys',
        },
        sutartisInfo: {
          title: 'Sutarties informacija',
          route: 'sutartisInfo',
          errorTab: 'sutarties-informacija',
        },
        sutartisDaiktas: {
          title: 'Sutarties dalykas',
          route: 'sutartisDaiktas',
          errorTab: 'sutarties-dalykas',
        },
        hipotekaRinkmenos: {
          title: 'Rinkmenos',
          route: 'hipotekaRinkmenos',
          errorTab: 'rinkmenos',
        },
        hipotekaInformavimas: {
          title: 'Informavimas',
          route: 'hipotekaInformavimas',
          errorTab: 'informavimas',
        },
        hipotekaRegistravimas: {
          title: 'Registravimas',
          route: 'hipotekaRegistravimas',
          errorTab: 'registrui',
        },
      }
    },

    turtasTitle() {
      const key = Object.keys(HipotekaMap['turtasTekstas']).find(e =>
        this.tabHipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['turtasTekstas'][key].title : null
    },
    ikaitoDavejaiTitle() {
      return this.tabHipotekaTipas.includes('priverstinis')
        ? 'Savininkai'
        : 'Įkaito davėjai'
    },
    ikaitoDavejaiTitleHR() {
      return this.tabHipotekaTipas.includes('priverstinis')
        ? 'Savininkai iš HR'
        : 'Įkaito davėjai iš HR'
    },
    prievoleTitle() {
      const key = Object.keys(HipotekaMap['prievoleTekstas']).find(e =>
        this.tabHipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['prievoleTekstas'][key].tab : null
    },
    salyginisTitle() {
      const key = Object.keys(HipotekaMap['salyginisTekstas']).find(e =>
        this.tabHipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['salyginisTekstas'][key].tab : null
    },
  },
}
